import * as React from 'react';
import * as ReactDOM from 'react-dom';
import * as _ from 'underscore';
import * as $ from 'jquery';
const compareObjects = require('fast-deep-equal');

import { IGlob } from '../ts/Glob';
import { ProgressBar } from '../../../_common/platform/tsx/ProgressBar';
import * as widgetDispatcher from '../ts/widgetDispatcher';
import * as updater from '../ts/updater';
import * as appTheme from '../../../_common/platform/ts/appTheme';
import serializeWorkspace from '../../../_common/platform/ts/serializeWorkspace';
import * as reactGlobalClick from '../../../_common/platform/ts/reactGlobalClick';
import { LayoutContainerSize } from './LayoutContainerSize';
import { CommandMenu, EditingActiveButtons } from './menus/CommandMenu';
import WorkspacesNavigation from './menus/WorkspacesNavigation';
import LayoutContainerBlock from './layout/LayoutContainerBlock';
import DirsTemplatesFlat from './DirsTemplatesFlat';
import ErrorBoundary from '../../../_common/platform/tsx/ErrorBoundary';
import LayoutCarousel from './LayoutCarousel';
import ApplicationLogo from './ApplicationLogo';
import IntroView from './IntroView';
import * as Utilities from '../../../_common/platform/ts/Utilities';
import GlobalState from '../../../_common/platform/ts/globalStates/GlobalState';
import { MenuModes } from './menus/Common';
import { WidgetData } from '../../../_common/platform/ts/WidgetData';
import { Widget } from './Widget';
import { config } from '../ts/config';

import {
    IDrillDownWidgetParameters,
    IURLQuery,
    IWidget,
    IWidgetOptions,
    IWidgetState,
    WorkspaceLayoutType
} from '../ts/Interfaces';

import { themeVars } from '../../../pdc-platform/src/ts/themes/themeConstants';
import { IScopeOptions } from '../../../_common/platform/tsx/filtering/Interfaces';
import { DirsTemplates } from './DirsTemplates';
import { WidgetBrief } from './WidgetBrief';
import { LayoutGrid } from './layout/LayoutGrid';
import { ThemeRenderer } from './ThemeRenderer';
import { openCreateWorkspaceLinkDialog } from './WorkspaceLinkParameters';
import { ITab } from '../ts/stores/AppStore';

import { IWorkspaceStoreState, IWorkspaceInstance, DisplayMode } from '../ts/stores/WorkspaceStore';

import { buildAttributeFilterWidgetFilterCollection } from '../../../_common/platform/tsx/filtering/AttributeFiltersCreator';
import { buildPeriodFilterWidgetPeriodFilter } from '../../../_common/platform/tsx/filtering/PeriodFiltersCreator';
import { getCultureValues } from '../../../_common/platform/ts/Globalization';
import { NavigationBar } from './menus/ToolbarButtons';
import { createNewScope } from '../../../_common/platform/tsx/filtering/FilterUtilities';
import { Dialogs } from './Dialogs';
import { IWidgetLayout } from './layout/Interfaces';

const PIN_NAVIGATION_BAR = 'pin-navigation-bar';

function workspaceIsNotSaved(instance: IWorkspaceInstance) {
    return (
        instance.edititngStarted &&
        instance.data != null &&
        instance.originalData != null &&
        serializeWorkspace(instance.data, true) !== instance.originalData
    );
}

function workspaceCanBeSaved(instance: IWorkspaceInstance, distractFree: boolean) {
    return instance.data != null && instance.name != null && distractFree !== true;
}

function inEditMode(instance: IWorkspaceInstance) {
    return instance.showGrid || instance.displayMode === 'widgets';
}

function findWidget(id: number | string, widgets: IWidget[]) {
    let recur = [];

    const find = _.find(widgets, (obj) => {
        if (obj.type === config.widgetTypes.tabbedWidget || obj.type === config.widgetTypes.nestedLayout) {
            recur = recur.concat(obj.values[obj.type].widgets);
        }

        if (typeof id === 'string') {
            return obj.values[obj.type].name === id;
        } else {
            return obj.id === id;
        }
    });

    if (find != null) {
        return find;
    } else if (recur.length > 0) {
        return findWidget(id, recur);
    }
}

function getAutoupdateInterval(theme: appTheme.IValuesCollection) {
    return theme[themeVars.workspaceAutoupdateInterval] as number;
}

function getPinNavigationBarValue(theme: appTheme.IValuesCollection, glob: IGlob) {
    const result = glob.AppStore.getFromLocalStorage(PIN_NAVIGATION_BAR);

    if (result == null) {
        return theme[themeVars.navigationBar_PinnedByDefault] !== false;
    }

    return result !== '0';
}

function workspaceIsNew(id: number) {
    return id == null || id < 0;
}

function getWidgetTheme(widgetParameters, workspaceTheme: appTheme.IValuesCollection) {
    let widgetTheme = widgetParameters.theme;
    let customTheme: appTheme.IValuesCollection;

    if (widgetTheme != null) {
        widgetTheme = { ...widgetTheme };
        customTheme = widgetTheme._custom;
        delete widgetTheme._custom;
    }

    return Utilities.mergeRecursive({}, workspaceTheme, widgetTheme, customTheme);
}

function applyWidgetFiltersForContainer(
    container: IWidget,
    widgetType: string,
    globalState: GlobalState,
    workspaceID: number,
    defs: JQueryDeferred<any>[],
    scopeOptions: IScopeOptions,
    delayInterval: number,
    theme: appTheme.IValuesCollection,
    tab: number,
    id: number,
    glob: IGlob
) {
    if (container.values == null) {
        return;
    }

    // Nested Layout and Workspace widgets only create a scope.
    // Creation of a scope must be here and in the widgets that can do it.
    let makeFiltersLocalConstant: string;

    if (widgetType === config.widgetTypes.nestedLayout) {
        makeFiltersLocalConstant = themeVars.widgetLayoutMakeFiltersLocal;
    } else if (widgetType === config.widgetTypes.workspace) {
        makeFiltersLocalConstant = themeVars.widgetWorkspaceMakeFiltersLocal;
    }

    if (makeFiltersLocalConstant != null) {
        const widgetParameters = container.values[widgetType];
        const widgetTheme = getWidgetTheme(widgetParameters, theme);

        if (widgetTheme == null || widgetTheme[makeFiltersLocalConstant] !== false) {
            scopeOptions = createNewScope(scopeOptions, container.id, tab);
        }
    }

    _.each(container.values, (value) => {
        let widgets: IWidget[];

        if (widgetType === config.widgetTypes.drillDown) {
            widgets = (value as IDrillDownWidgetParameters).drillDown.widgets;
        } else {
            widgets = value.widgets;
        }

        applyWidgetFilters(globalState, widgets, workspaceID, scopeOptions, delayInterval, theme, tab, id, glob, defs);
    });
}

function applyWidgetFilters(
    globalState: GlobalState,
    widgets: IWidget[],
    workspaceID: number,
    scopeOptions: IScopeOptions,
    delayInterval: number,
    theme: appTheme.IValuesCollection,
    tab: number,
    id: number,
    glob: IGlob,
    defs: JQueryDeferred<any>[] = []
) {
    const result = $.Deferred();

    _.each(widgets, (widget) => {
        if (widget.values != null) {
            const widgetType = widget.type;

            if (
                widgetType === config.widgetTypes.nestedLayout ||
                widgetType === config.widgetTypes.tabbedWidget ||
                widgetType === config.widgetTypes.workspace ||
                widgetType === config.widgetTypes.drillDown
            ) {
                applyWidgetFiltersForContainer(
                    widget,
                    widgetType,
                    globalState,
                    workspaceID,
                    defs,
                    scopeOptions,
                    delayInterval,
                    theme,
                    tab,
                    id,
                    glob
                );
            } else if (widgetType === config.widgetTypes.attributeFilter) {
                const widgetData = WidgetData.getFromObj(widget, glob, false);
                const def = globalState.makeDeferred();

                defs.push(def);

                widgetData.def.done(() => {
                    // Default Theme and Widget Parameters are now applied.
                    const widgetParameters = widgetData.values[config.widgetTypes.attributeFilter];
                    const widgetTheme = getWidgetTheme(widgetParameters, theme);
                    const cultureValues = getCultureValues(widgetTheme);

                    buildAttributeFilterWidgetFilterCollection(
                        false,
                        widgetParameters,
                        globalState,
                        widget.id,
                        scopeOptions,
                        id,
                        widgetTheme,
                        cultureValues,
                        glob,
                        (filterCollections) => {
                            globalState.addToAttributeFilterCollection(
                                filterCollections,
                                widget.id,
                                delayInterval,
                                false
                            );
                        }
                    ).always(() => {
                        def.resolve();
                    });
                });
            } else if (widgetType === config.widgetTypes.periodFilter) {
                const widgetData = WidgetData.getFromObj(widget, glob, false);
                const def = globalState.makeDeferred();

                defs.push(def);

                widgetData.def
                    .done(() => {
                        // Default Theme and Widget Parameters are now applied.
                        const widgetParameters = widgetData.values[config.widgetTypes.periodFilter];
                        const widgetTheme = getWidgetTheme(widgetParameters, theme);
                        const periodFilter = buildPeriodFilterWidgetPeriodFilter(
                            widgetParameters,
                            scopeOptions,
                            widgetTheme,
                            glob
                        );

                        if (!_.isEmpty(periodFilter)) {
                            globalState.addToPeriodFilter(periodFilter, scopeOptions);
                        }

                        def.resolve();
                    })
                    .fail(() => {
                        def.resolve();
                    });
            }
        }
    });

    $.when(...defs)
        .done(() => {
            result.resolve();
        })
        .fail(() => {
            result.resolve();
        });

    return result;
}

function applyFiltersQuery(
    state: IWorkspaceState,
    query: IURLQuery,
    id: number,
    theme: appTheme.IValuesCollection,
    props: IWorkspaceProperties
) {
    const instance = state.instance;

    if (instance == null || instance.data == null) {
        return;
    }

    const def = state.globalState.makeDeferred();

    applyWidgetFilters(
        state.globalState,
        instance.data.widgets,
        instance.id,
        props.scopeOptions,
        -1,
        theme,
        props.tab,
        id,
        props.glob
    )
        .done(() => {
            state.globalState.setFiltersFromURL(query, id, props.widget, theme, -1).always(() => {
                def.resolve();
            });
        })
        .fail(() => {
            def.resolve();
        })
        .always(() => {
            const { tab } = props.glob.AppStore.getTabInfo(props.tab);

            if (tab != null && !tab.openedInternaly && props.mainTab == null) {
                props.glob.AppActions.dropWorkspaceQuery(tab.id);
            }
        });

    def.done(() => {
        state.globalState.riseWorkspaceSetStateEvent(0);
    });
}

function registerWidgetsInitAndApplyFilters(
    state: IWorkspaceState,
    widgetID: number,
    theme: appTheme.IValuesCollection,
    id: number,
    props: IWorkspaceProperties
) {
    const { data } = state.instance;

    if (data == null || data.widgets == null) {
        return;
    }

    let widgetsToInit = data.widgets;

    if (widgetID != null) {
        const widget = findWidget(widgetID, widgetsToInit);

        if (widget != null) {
            widgetsToInit = [widget];
        }
    }

    widgetDispatcher.registerWidgetsInit(state.contextId, widgetsToInit);

    let query = props.query;

    if (query == null && props.widgetState != null) {
        query = props.widgetState.query;
    }

    if (query != null) {
        applyFiltersQuery(state, query, id, theme, props);
    } else {
        applyWidgetFilters(
            state.globalState,
            data.widgets,
            state.instance.id,
            props.scopeOptions,
            50,
            theme,
            props.tab,
            id,
            props.glob
        );
    }
}

function askToSaveChanges(
    workspaceID: number,
    tab: ITab,
    currentInstance: IWorkspaceInstance,
    storeState: IWorkspaceStoreState,
    theme: appTheme.IValuesCollection,
    glob: IGlob,
    isNew: boolean,
    isSame?: boolean
) {
    const resultDef = $.Deferred();
    const workspaceInstance = storeState.instances[workspaceID];
    const isNotSaved = workspaceIsNotSaved(workspaceInstance);
    const contentChanged = tab.contentChanged != null;
    const result = {
        def: resultDef,
        workspaceIsNotSaved: isNotSaved,
        contentChanged: contentChanged
    };
    const contentChangedDef = $.Deferred();

    if (contentChanged) {
        const unsavedContentPromptTitle = theme[themeVars.unsavedContentPromptTitle];
        const unsavedContentPromptMessage = theme[themeVars.unsavedContentPromptMessage];

        glob.DialogActions.createDialog(
            unsavedContentPromptTitle || config.UNSAVED_WORKSPACE_CHANGES_WILL_BE_LOST_TITLE,
            unsavedContentPromptMessage || config.UNSAVED_WORKSPACE_CHANGES_WILL_BE_LOST_MESSAGE,
            () => {
                contentChangedDef.resolve();
            },
            () => {
                contentChangedDef.reject();
            },
            () => {
                contentChangedDef.reject();
            },
            'confirm',
            {
                confirmTitle: 'Drop changes',
                cancel: false
            }
        );
    } else {
        contentChangedDef.resolve();
    }

    contentChangedDef.done(() => {
        if (isSame || (!isNew && !isNotSaved)) {
            resultDef.resolve();
            return result;
        }

        if (workspaceID == null || workspaceInstance == null || workspaceInstance.originalData == null) {
            resultDef.resolve();
            return result;
        }

        const instanceData = serializeWorkspace(workspaceInstance.data, true);

        if (instanceData === workspaceInstance.originalData) {
            resultDef.resolve();
            return result;
        }

        glob.DialogActions.createDialog(
            config.UNSAVED_WORKSPACE_CHANGES_WILL_BE_LOST_TITLE,
            config.UNSAVED_WORKSPACE_CHANGES_WILL_BE_LOST_MESSAGE,
            () => {
                if (!isNew) {
                    glob.AppActions.workspaceSave(workspaceID, instanceData, currentInstance.dateUpdated);
                    resultDef.resolve();
                } else {
                    glob.AppActions.workspaceSaveAs(workspaceID, currentInstance.data, true, resultDef);
                }
            },
            () => {
                resultDef.resolve();
            },
            () => {
                resultDef.reject();
            },
            'confirm',
            {
                confirmTitle: 'Save changes',
                cancelTitle: 'Drop changes'
            }
        );
    });

    return result;
}

function createTheme(
    state: IWorkspaceState,
    workspaceTheme: appTheme.IValuesCollection,
    widgetTheme: appTheme.IValuesCollection = {}
) {
    const dataTheme = state.instance.data?.theme;

    return appTheme.extend({}, workspaceTheme, dataTheme ?? {}, dataTheme?._custom, widgetTheme);
}

export interface IWorkspaceProperties {
    id: number;
    cid: number;
    key: string;
    tab: number; // It can be a index of tab or a tab ID. It's a crazy solution of Taras.
    actualTab?: number; // Is set when 'tab' is substituted as for Widget Maximize.
    mainTab: number;
    widgetMode?: boolean;
    hidden?: boolean;
    isChildWorkspace: boolean;
    tabs: ITab[];
    tabDisplay: number;
    widget: number;
    widgetsDistractFree?: boolean;
    distractFree?: boolean;
    widgetsHideEdit?: boolean;
    theme?: appTheme.IValuesCollection;
    widgetTheme?: appTheme.IValuesCollection;
    widgetState?: IWidgetState; // Optional initial data, may be sent in URL
    widgetQuery?: { [key: string]: string };
    query?: IURLQuery;
    disableSizeMixin?: boolean;
    scopeOptions?: IScopeOptions;
    globalState?: GlobalState;
    contentChanged?: boolean;
    glob: IGlob;
}

export interface IWorkspaceState {
    key?: number;
    contextId?: number;
    storeState: IWorkspaceStoreState;
    instance: IWorkspaceInstance;

    widgetLayoutEdit?: number;
    subMenu?: any[];
    menuMode?: MenuModes;
    namespaces?: any;
    globalState?: GlobalState;

    viewportWidth?: number;
    viewportHeight?: number;
    navigationBarHeight?: number;
    navigationWidth?: number;
    navigationAndLogoWidth?: number;
    showFloatingNavigationBar?: boolean;
    updateKey?: number;
    overwrite?: boolean;
    widgetDataEdit?: any;
    layoutCarouselCurrentWidgetId?: number;
}

export default class Workspace extends React.Component<IWorkspaceProperties, IWorkspaceState> {
    private globalClickIndex: number;

    private refrences: {
        navigationBar?: HTMLDivElement;
        leftLogo?: HTMLDivElement;
    } = {};

    constructor(props) {
        super(props);

        const id = this.props.id ?? this.props.cid;

        let defaultsFlag = false;

        if (this.props.id == null) {
            defaultsFlag = true;
        }

        const contextId = widgetDispatcher.createWorkspaceContext();
        const namespace = 'business-intelligence';

        let navigationBarHeight = 0;

        if (!this.props.distractFree) {
            navigationBarHeight = this.props.glob.AppStore.getLastNavigationBarHeight();
        }

        const state: IWorkspaceState = {
            ...this.getState(id, defaultsFlag),
            key: id,
            widgetLayoutEdit: null,
            menuMode: MenuModes.sideBar,
            subMenu: [],
            contextId: contextId,
            navigationBarHeight: navigationBarHeight,
            navigationWidth: 0,
            navigationAndLogoWidth: 0,
            updateKey: 0
        };

        if (this.props.globalState == null) {
            state.globalState = GlobalState.createFactory(
                this.props.glob,
                id,
                this.props.tab,
                namespace,
                state.namespaces[namespace]
            );
        } else {
            state.globalState = this.props.globalState;
        }

        const theme = createTheme(state, this.props.theme);

        this.state = state;
        registerWidgetsInitAndApplyFilters(state, this.props.widget, theme, id, this.props);
    }

    getState(id: number, defaults = false): IWorkspaceState {
        return {
            namespaces: { ...this.props.glob.WorkspaceStore.getWorkspaceState(id, this.props.tab) },
            storeState: { ...this.props.glob.WorkspaceStore.getState() },
            instance: { ...this.props.glob.WorkspaceStore.getInstanceState(id, defaults) }
        };
    }

    getTheme = (widgetTheme?: appTheme.IValuesCollection) => {
        return createTheme(this.state, this.props.theme, widgetTheme);
    };

    handleOnWorkspaceStoreChange = () => {
        this.setState(this.getState(this.state.key));
    };

    handleOnNavAndLogoChange = (navigationWidth?: number) => {
        const menuOrientation = this.props.glob.SettingsStore.getMenuOrientation();
        const leftLogoElement = this.refrences.leftLogo;
        const logoPosition = this.props.glob.SettingsStore.getApplicationLogoPosition();

        if (menuOrientation === 'Vertical') {
            if (leftLogoElement != null && logoPosition === 'left') {
                this.setState({
                    navigationAndLogoWidth: leftLogoElement.clientWidth
                });
            }
        } else {
            let navigationAndLogoWidth = navigationWidth != null ? navigationWidth : this.state.navigationWidth;

            if (leftLogoElement != null && logoPosition === 'left') {
                navigationAndLogoWidth += leftLogoElement.clientWidth;
            }

            this.setState({
                navigationWidth: navigationWidth,
                navigationAndLogoWidth: navigationAndLogoWidth
            });
        }
    };

    initiateWorkspaceUpdate = (auto = true) => {
        const id = this.props.id ?? this.props.cid;

        this.props.glob.AppActions.workspaceUpdateInitiate(auto, id, this.props.tab);
    };

    handleOnUnload = (e) => {
        if (this.props.distractFree) {
            return;
        }

        const isNew = workspaceIsNew(this.props.id);

        if (!isNew && !inEditMode(this.state.instance)) {
            return;
        }

        const { instance } = this.state;
        const dataStr = serializeWorkspace(instance.data, true);

        let confirmationMessage: string;

        if (instance.originalData != null && dataStr !== instance.originalData) {
            if (this.props.id == null) {
                confirmationMessage = config.UNSAVED_WORKSPACE_CHANGES_WILL_BE_LOST_MESSAGE;
            } else {
                confirmationMessage = config.UNSAVED_WORKSPACE_CHANGES_MESSAGE_UNLOAD;
            }

            (e || window.event).returnValue = confirmationMessage;

            return confirmationMessage;
        }
    };

    componentDidMount() {
        const { glob, widget, widgetState } = this.props;
        const { data } = this.state.instance;
        const menuOrientation = glob.SettingsStore.getMenuOrientation();

        glob.WorkspaceStore.addChangeListener(this.handleOnWorkspaceStoreChange);
        glob.WorkspaceStore.setWorkspaceIsChild(this.props.id, this.props.isChildWorkspace);

        if (menuOrientation === 'Horizontal') {
            this.setState({ menuMode: MenuModes.horizontal });
            glob.AppActions.workspaceCustomMenuLoad(false);
        }

        $(window).on('beforeunload', this.handleOnUnload);

        this.globalClickIndex = reactGlobalClick.register(() => {
            this.props.glob.AppActions.workspaceHideSidebar();
        });

        const id = this.props.id ?? this.props.cid;
        const theme = this.getTheme();

        updater.register(id, getAutoupdateInterval(theme), this.initiateWorkspaceUpdate);

        if (widget != null && data != null && data.widgets != null) {
            const existingWidget = findWidget(widget, data.widgets);

            if (existingWidget == null) {
                glob.AppActions.showNotification_Fail(
                    'Widget with key ' + widget + ' is not found. Possibly deleted from the workspace'
                );
            }
        }

        if (widgetState != null && data != null) {
            if (widgetState.query != null) {
                this.state.globalState.setFiltersFromURL(widgetState.query, id, widget, theme);
            }
        }

        this.setNavigationBarHeight();

        const showLogo = this.props.distractFree === false || (widgetState != null && widgetState.showAppLogo);

        if (showLogo) {
            const logo = glob.SettingsStore.getApplicationLogo();

            if (logo != null && logo !== '') {
                this.handleOnNavAndLogoChange();
            }
        }

        glob.EntityModelsActions.loadDataSources();
    }

    setNavigationBarHeight = () => {
        if (this.props.distractFree) {
            return;
        }

        const navigationBar = this.refrences.navigationBar;

        let navigationBarHeight: number;

        if (navigationBar != null) {
            navigationBarHeight = navigationBar.clientHeight;

            if (navigationBarHeight != null) {
                this.props.glob.AppStore.saveLastNavigationBarHeight(navigationBarHeight);

                if (navigationBarHeight !== this.state.navigationBarHeight) {
                    this.setState({
                        navigationBarHeight: navigationBarHeight
                    });
                }
            }
        }
    };

    componentWillUnmount() {
        const { data } = this.state.instance;

        if (data != null && data.widgets != null && this.props.widget == null) {
            widgetDispatcher.registerWidgetsDestroy(this.state.contextId, data.widgets);
        }

        const id = this.props.id ?? this.props.cid;

        updater.stop(id);

        this.props.glob.WorkspaceStore.removeChangeListener(this.handleOnWorkspaceStoreChange);

        reactGlobalClick.unregister(this.globalClickIndex);
        this.globalClickIndex = null;

        $(window).off('beforeunload', this.handleOnUnload);

        // Make before close call.
        if (this.props.widget == null) {
            setTimeout(() => {
                widgetDispatcher.destroyWorkspaceContext(this.state.contextId);
                this.props.glob.AppActions.workspaceBeforeClose(id, this.props.tab);
            }, 0);
        }
    }

    componentDidUpdate(prevProps, prevState) {
        const mayShowLogo = this.props.distractFree === false || this.props.widgetState?.showAppLogo;

        if (mayShowLogo) {
            if (this.props.widgetMode !== true) {
                const logo = this.props.glob.SettingsStore.getApplicationLogo();

                if (logo != null && logo !== '') {
                    this.handleOnNavAndLogoChange();
                }
            }
        }
    }

    componentWillUpdate(nextProps: IWorkspaceProperties, nextState: IWorkspaceState) {
        const { data } = this.state.instance;
        //LL: on 1st change: this.state.layoutCarouselCurrentWidgetId is null
        //            before 1st change: both are null
        let lcCurrentWidgetId = this.state.layoutCarouselCurrentWidgetId;

        if (lcCurrentWidgetId == null) {
            // 1st change
            if (data != null && data.widgets != null && data.widgets.length > 0) {
                lcCurrentWidgetId = data.widgets[0].id;
            }
        }

        const emitWidgetWillHide =
            nextState.layoutCarouselCurrentWidgetId != null &&
            lcCurrentWidgetId !== nextState.layoutCarouselCurrentWidgetId;

        //LL: there is Constants.WIDGET_SET_HIDDEN, use it ?  by AppActions.widgetSetHidden
        if (emitWidgetWillHide) {
            this.props.glob.AppActions.widgetSetHidden(this.props.tab, this.props.id, lcCurrentWidgetId, true);
            //LL: or maybe "next" better to set hidden (actually "shown") in componentDidUpdate ? Yes
            this.props.glob.AppActions.widgetSetHidden(
                this.props.tab,
                this.props.id,
                nextState.layoutCarouselCurrentWidgetId,
                false
            );
        }

        const nextID = nextProps.id ?? nextProps.cid;
        const nextTheme = createTheme(nextState, nextProps.theme);

        if (
            (data == null || data.widgets == null) &&
            nextState.instance.data != null &&
            nextState.instance.data.widgets != null
        ) {
            registerWidgetsInitAndApplyFilters(nextState, nextProps.widget, nextTheme, nextID, nextProps);

            const nextQuery = nextProps.widgetState?.query;

            if (nextQuery != null) {
                nextState.globalState.setFiltersFromURL(nextQuery, nextID, nextProps.widget, nextTheme);
            }
        } else {
            const nextQuery = nextProps.query;

            if (nextQuery != null && !compareObjects(this.props.query, nextQuery)) {
                applyFiltersQuery(nextState, nextQuery, nextID, nextTheme, nextProps);
            }
        }

        //VR: this was wrong! works only after <F5>:
        updater.register(nextID, getAutoupdateInterval(nextTheme), this.initiateWorkspaceUpdate);
    }

    componentWillReceiveProps(nextProps: IWorkspaceProperties) {
        if (nextProps.id !== this.props.id) {
            this.setState(this.getState(nextProps.id));
        }
    }

    shouldComponentUpdate(nextProps: IWorkspaceProperties, nextState: IWorkspaceState) {
        return (
            !_.isEqual(this.props, nextProps) ||
            !_.isEqual(this.state, nextState) ||
            !(this.state.instance.data === nextState.instance.data) ||
            !(
                this.state.widgetDataEdit === nextState.widgetDataEdit ||
                !_.isEqual(this.props.tabs[this.props.tabDisplay], nextProps.tabs[nextProps.tabDisplay])
            )
        );
    }

    handleOnToggleWorkspacesNavigationBar = () => {
        if (this.state.storeState.showSidebar) {
            this.props.glob.AppActions.workspaceHideSidebar();
        } else {
            this.props.glob.AppActions.workspaceShowSidebar();
        }

        reactGlobalClick.cancel(1);
    };

    setDisplayMode = (displayMode: DisplayMode, showGrid: boolean) => {
        this.props.glob.WorkspaceActions.setWorkspacePresentationMode(
            this.props.tab,
            this.state.instance.id,
            displayMode,
            showGrid
        );
    };

    handleOnTogglingGridMode = () => {
        const { instance } = this.state;

        this.setDisplayMode(instance.displayMode, !instance.showGrid);
    };

    handleOnTogglingDisplayMode = () => {
        const { instance } = this.state;

        if (!instance.showGrid && instance.displayMode === 'widgets') {
            this.setDisplayMode('main', false);
        } else {
            this.setDisplayMode('widgets', false);
        }
    };

    handleOnSaveWorkspace = () => {
        const { instance } = this.state;

        if (this.state.storeState.actionLoading || instance.id == null) {
            return;
        }

        const def = $.Deferred();

        this.props.glob.AppActions.workspaceHideSidebar();
        this.props.glob.AppActions.workspaceSave(
            instance.id,
            serializeWorkspace(instance.data, true, true, this.props.glob),
            instance.dateUpdated,
            def
        );

        def.done(() => {
            this.setDisplayMode('main', false);
        });
    };

    handleOnSaveWorkspaceAs = () => {
        this.props.glob.AppActions.workspaceSaveAs(this.props.id, this.state.instance.data, false);
        this.setDisplayMode('main', false);
    };

    handleOnResetWorkspaceChanges = () => {
        const { id } = this.state.instance;

        if (this.state.storeState.actionLoading || id == null) {
            return;
        }

        const { glob } = this.props;
        const currentTab = this.props.tabs[this.props.tabDisplay];
        const theme = this.getTheme();

        askToSaveChanges(id, currentTab, this.state.instance, this.state.storeState, theme, glob, false).def.done(
            () => {
                glob.AppActions.workspaceHideSidebar();
                glob.AppActions.workspaceReset(id);
                this.setDisplayMode('main', false); // See Issue 87089.
            }
        );
    };

    handleOnShowWidgetTemplates = (show: boolean) => {
        this.props.glob.AppActions.showWorkspaceTemplateSidebar(this.state.instance.id, show);
    };

    handleOnCreateWorkspaceLink = () => {
        const { instance } = this.state;

        if (this.state.storeState.actionLoading || instance.id == null) {
            return;
        }

        openCreateWorkspaceLinkDialog(
            instance.id,
            this.props.tab,
            this.props.tabDisplay,
            instance.name,
            this.props.scopeOptions,
            this.props.glob
        );
    };

    handleOnWorkspacesNavSelect = (workspaceID: number, mode: MenuModes) => {
        const { glob } = this.props;
        const currentTab = this.props.tabs[this.props.tabDisplay];
        const performNavSelect = () => {
            const theme = this.getTheme();
            const isNew = currentTab.workspaceID == null;
            const { def, workspaceIsNotSaved } = askToSaveChanges(
                currentTab.workspaceID || currentTab.cid,
                currentTab,
                this.state.instance,
                this.state.storeState,
                theme,
                glob,
                isNew
            );

            def.done(() => {
                if (!isNew) {
                    // Close the current saved workspace to store its selections.
                    glob.AppActions.workspaceViewClose(
                        currentTab.workspaceID,
                        this.props.tabDisplay,
                        workspaceIsNotSaved,
                        true
                    );
                }

                if (mode === MenuModes.sideBar) {
                    glob.AppActions.workspaceCustomMenuLoad(true);
                    glob.AppActions.workspaceHideSidebar();
                }

                glob.mainRouter.navigate('/tabs/' + this.props.tabDisplay + '/workspaces/' + workspaceID, {
                    trigger: true
                });
            });
        };

        if (typeof glob.appSpecificOnNavSelect === 'function') {
            glob.appSpecificOnNavSelect({
                query: this.props.query,
                tabId: this.props.cid,
                glob: glob,
                contentChanged: currentTab.contentChanged
            }).done(() => {
                performNavSelect();
            });
        } else {
            performNavSelect();
        }
    };

    handleOnLayoutReset = () => {
        this.props.glob.AppActions.workspaceLayoutReset(this.state.instance.id);
    };

    handleOnLayoutChange = (layout: IWidgetLayout) => {
        this.props.glob.AppActions.workspaceLayoutSet(this.state.instance.id, layout);
    };

    handleOnDrop = (payload, x, y) => {
        if (payload.type === 'template') {
            const data = JSON.parse(JSON.stringify(payload.data));
            const cid = Utilities.getNewID();
            const id = this.state.instance.id;

            delete data.id;
            delete data.cid;

            data.cid = cid;

            this.props.glob.AppActions.widgetCreate(id, cid, data);
            this.props.glob.AppActions.widgetAttach(id, cid, x, y, false, true);
        }
    };

    handleOnWidgetAdd = (x, y) => {
        const theme = this.getTheme();

        this.props.glob.AppActions.workspaceAddWidget(this.state.instance.id, theme, this.props.tab, [x, y]);
        this.props.glob.AppActions.widgetEditShow();
    };

    handleOnTogglePinNavigationBar = () => {
        const theme = this.getTheme();
        const newValue = !getPinNavigationBarValue(theme, this.props.glob);

        this.props.glob.AppStore.saveToLocalStorage(PIN_NAVIGATION_BAR, newValue ? '1' : '0');

        this.setState(
            {
                showFloatingNavigationBar: false,
                updateKey: this.state.updateKey + 1
            },
            () => {
                // EVG 18.10.23:
                // When Navigation Bar is unpinned by default and it has not been shown yet its height is zero.
                // In such a case the height should be set after Navigation Bar is shown.
                // That is why Workspace is refreshed to draw Navigation Bar and then again to adjust the content.
                // After that the height is set and extra refreshing does not happen.
                if (newValue && this.state.navigationBarHeight === 0) {
                    this.setNavigationBarHeight();
                }
            }
        );
    };

    handleOnNavigationBarMouseOver = (e) => {
        e.stopPropagation();
        e.preventDefault();

        if (this.state.showFloatingNavigationBar) {
            return;
        }

        this.setState({ showFloatingNavigationBar: true });
    };

    handleOnNavigationBarMouseOut = () => {
        if (!this.state.showFloatingNavigationBar) {
            return;
        }

        this.setState({ showFloatingNavigationBar: false });
    };

    handleOnWorkspaceRemove = (id: number, tabIndex: number, isNew: boolean, isSame: boolean) => {
        const { glob } = this.props;
        const tabs = glob.AppStore.getTabs();
        const tab = tabs[tabIndex];
        const theme = this.getTheme();
        const { def, workspaceIsNotSaved, contentChanged } = askToSaveChanges(
            id,
            tab,
            this.state.instance,
            this.state.storeState,
            theme,
            glob,
            isNew,
            isSame
        );

        def.done(() => {
            const clearWorkspaceCache = !isSame && workspaceIsNotSaved;

            if (typeof glob.appSpecificOnNavSelect === 'function') {
                glob.appSpecificOnNavSelect({
                    query: tab?.query,
                    tabId: tab?.cid,
                    glob: glob,
                    contentChanged: contentChanged
                }).done(() => {
                    glob.AppActions.workspaceViewClose(id, tabIndex, clearWorkspaceCache);
                });
            } else {
                glob.AppActions.workspaceViewClose(id, tabIndex, clearWorkspaceCache);
            }
        });
    };

    handleWidgetLayoutEdit = (key: number) => {
        const { instance } = this.state;
        const widgetData = _.find(instance.data.widgets, ({ id, cid }) => id === key || cid === key);

        if (widgetData == null) {
            return;
        }

        const theme = this.getTheme();

        this.props.glob.AppActions.widgetEdit(instance.id, widgetData, theme, this.props.tab);
        this.props.glob.AppActions.widgetEditShow();
    };

    getWidgetLayoutModeChangeHandler = (key: number) => {
        return (layoutEdit: boolean) => {
            if (layoutEdit === true) {
                this.setState({
                    widgetLayoutEdit: key
                });
            } else if (key === this.state.widgetLayoutEdit) {
                this.setState({
                    widgetLayoutEdit: null
                });
            }
        };
    };

    handleOnEditWorkspaceTheme = () => {
        if (this.props.id == null) {
            this.props.glob.AppActions.showNotification_Fail('To edit advanced settings, please save workspace first.');
            return;
        }

        const { instance } = this.state;

        this.props.glob.AppActions.workspaceShow(instance.id, instance.name, instance.data);
    };

    getEditingActiveButtons = (
        displayMode: DisplayMode,
        showGrid: boolean,
        workspaceCanBeSaved: boolean,
        isNew: boolean,
        workspaceIsNotSaved: boolean,
        showWidgetTemplates: boolean
    ) => {
        return (
            <EditingActiveButtons
                key="editing-active-buttons"
                displayMode={displayMode}
                showGrid={showGrid}
                workspaceCanBeSaved={workspaceCanBeSaved}
                workspaceIsNew={isNew}
                workspaceIsNotSaved={workspaceIsNotSaved}
                showWidgetTemplates={showWidgetTemplates}
                onEditWorkspace={this.handleOnTogglingDisplayMode}
                onShowGrid={this.handleOnTogglingGridMode}
                onSave={this.handleOnSaveWorkspace}
                onSaveAs={this.handleOnSaveWorkspaceAs}
                onResetChanges={this.handleOnResetWorkspaceChanges}
                onShowWidgetTemplates={this.handleOnShowWidgetTemplates}
            />
        );
    };

    getTopActiveButtons = (displayMode: DisplayMode) => {
        const isNew = workspaceIsNew(this.props.id); // Virtual Worksapces with no ID should not show editing buttons.
        const { instance } = this.state;
        const isNotSaved = workspaceIsNotSaved(instance);
        const { showGrid, showDirsTemplatesSidebar } = instance;
        const canBeSaved = workspaceCanBeSaved(instance, this.props.distractFree);

        return this.getEditingActiveButtons(
            displayMode,
            showGrid,
            canBeSaved,
            isNew,
            isNotSaved,
            showDirsTemplatesSidebar
        );
    };

    handleManualWorkspaceUpdate = () => {
        this.initiateWorkspaceUpdate(false);
    };

    getCommandMenu = (
        displayMode: DisplayMode,
        layoutType: WorkspaceLayoutType,
        showEditingActiveButtons: boolean,
        theme: appTheme.IValuesCollection,
        additionalStyle?: React.CSSProperties
    ) => {
        const isNew = workspaceIsNew(this.props.id); // Virtual Worksapces with no ID should not show editing buttons.
        const { instance } = this.state;
        const isNotSaved = workspaceIsNotSaved(instance);
        const { showGrid, showDirsTemplatesSidebar } = instance;
        const canBeSaved = workspaceCanBeSaved(instance, this.props.distractFree);

        let editingActiveButtons: React.JSX.Element;

        if (showEditingActiveButtons) {
            editingActiveButtons = this.getEditingActiveButtons(
                displayMode,
                showGrid,
                canBeSaved,
                isNew,
                isNotSaved,
                showDirsTemplatesSidebar
            );
        }

        return (
            <CommandMenu
                key="command-menu"
                displayMode={displayMode}
                showGrid={showGrid}
                theme={theme}
                layoutType={layoutType}
                commandButtonStyle={additionalStyle}
                workspaceIsNew={isNew}
                workspaceCanBeSaved={canBeSaved}
                workspaceIsNotSaved={isNotSaved}
                showWidgetTemplates={showDirsTemplatesSidebar}
                editingActiveButtons={editingActiveButtons}
                glob={this.props.glob}
                onEditWorkspace={this.handleOnTogglingDisplayMode}
                onShowGrid={this.handleOnTogglingGridMode}
                onEditTheme={this.handleOnEditWorkspaceTheme}
                onLayoutReset={this.handleOnLayoutReset}
                onSave={this.handleOnSaveWorkspace}
                onSaveAs={this.handleOnSaveWorkspaceAs}
                onResetChanges={this.handleOnResetWorkspaceChanges}
                onCreateWorkspaceLink={this.handleOnCreateWorkspaceLink}
                onRefreshWorkspace={this.handleManualWorkspaceUpdate}
            />
        );
    };

    getWidgetDistractFree = () => {
        if (this.props.widgetsDistractFree != null) {
            return this.props.widgetsDistractFree;
        }

        return this.props.distractFree;
    };

    getWidetOptions = () => {
        let result: IWidgetOptions;

        if (this.props.scopeOptions != null) {
            result = {
                scopeOptions: this.props.scopeOptions
            };
        }

        if (this.props.actualTab != null) {
            if (result == null) {
                result = {};
            }

            result.maximized = true;
        }

        return result;
    };

    renderWidgets = (theme: appTheme.IValuesCollection, displayMode: DisplayMode) => {
        const forceHideHeaderOnMobile = config.LAYOUT_TYPE === 'narrow' && this.props.distractFree !== true;
        const indicatorGap = config.LAYOUT_TYPE === 'narrow' && this.props.distractFree === true ? 40 : 0;
        const { instance } = this.state;

        return _.map(instance.data.widgets, (widget) => {
            const widgetID = widget.id ?? widget.cid;
            const local = instance.data.widgetsLocal[widgetID] || {};
            const options = this.getWidetOptions();
            const style = {
                top: 0,
                left: 0,
                width: '100%',
                height: '100%'
            };

            widget = _.extend({}, widget, local);

            return (
                <Widget
                    style={style}
                    key={widgetID}
                    _key={widgetID}
                    data={widget}
                    tab={this.props.tab}
                    mainTab={this.props.mainTab}
                    workspace={instance.id}
                    namespaces={this.state.namespaces}
                    workspaceContextId={this.state.contextId}
                    distractFree={this.getWidgetDistractFree()}
                    hideEdit={this.props.widgetsHideEdit}
                    isWorkspaceSaved={this.props.id != null}
                    theme={theme}
                    widgetState={this.props.widgetState}
                    displayMode={displayMode}
                    forceHideHeader={forceHideHeaderOnMobile}
                    disableSizeMixin={true}
                    hidden={this.props.hidden}
                    layoutEdit={widgetID === this.state.widgetLayoutEdit}
                    layoutData={{
                        parentHeight: this.state.viewportHeight - indicatorGap,
                        parentWidth: this.state.viewportWidth
                    }}
                    globalState={this.state.globalState}
                    options={options}
                    glob={this.props.glob}
                    onLayoutModeChange={this.getWidgetLayoutModeChangeHandler(widgetID)}
                />
            );
        });
    };

    handleOnLayoutCarouselChange = (widgetID: number) => {
        this.setState({
            layoutCarouselCurrentWidgetId: widgetID
        });
    };

    getLayout = (displayMode: DisplayMode) => {
        if (this.state.viewportWidth == null || this.state.viewportHeight == null) {
            return;
        }

        const theme = this.getTheme();
        const widgets = this.renderWidgets(theme, displayMode);
        const layoutType = config.LAYOUT_TYPE;
        const { instance } = this.state;

        if (layoutType === 'narrow' && widgets.length > 1) {
            const indicatorgap = this.props.distractFree === true ? 40 : 0;

            return (
                <LayoutCarousel
                    widgets={instance.data.widgets}
                    currentWidgetId={this.state.layoutCarouselCurrentWidgetId}
                    viewportWidth={this.state.viewportWidth}
                    viewportHeight={this.state.viewportHeight - indicatorgap}
                    displayMode={displayMode}
                    distractFree={this.props.distractFree}
                    hidden={this.props.hidden}
                    onChange={this.handleOnLayoutCarouselChange}
                    onSpecialAction={this.handleWidgetLayoutEdit}
                >
                    {widgets}
                </LayoutCarousel>
            );
        } else {
            return (
                <LayoutGrid
                    viewportWidth={this.state.viewportWidth}
                    viewportHeight={this.state.viewportHeight}
                    layout={instance.data.layout}
                    elements={instance.data.widgets}
                    displayMode={displayMode}
                    showGrid={instance.showGrid}
                    hidden={this.props.hidden}
                    workspace={this.props.id || this.props.cid}
                    tab={this.props.tab}
                    glob={this.props.glob}
                    onElementAdd={this.handleOnWidgetAdd}
                    onLayoutChange={this.handleOnLayoutChange}
                    onDrop={this.handleOnDrop}
                    onSpecialAction={this.handleWidgetLayoutEdit}
                >
                    {widgets}
                </LayoutGrid>
            );
        }
    };

    getWidgets = (displayMode: DisplayMode) => {
        const { instance } = this.state;
        const { data } = instance;

        let isValid = true;

        if (Array.isArray(data.widgets)) {
            if (
                data.widgets.find((obj) => {
                    return !(
                        typeof obj.type === 'string' &&
                        typeof obj.id === 'number' &&
                        typeof obj.values === 'object'
                    );
                }) != null
            ) {
                isValid = false;
            }
        } else {
            isValid = false;
        }

        if (!isValid) {
            return <span>{'JSON is not valid'}</span>;
        }

        let widgetComponent: React.JSX.Element;
        let widget: IWidget;

        if (this.props.widget != null) {
            widget = findWidget(this.props.widget, data.widgets);
        }

        if (widget != null) {
            const widgetID = widget.id ?? widget.cid;
            const theme = this.getTheme(this.props.widgetTheme);
            const options = this.getWidetOptions();

            widget = _.extend({}, widget, data.widgetsLocal[widgetID] || {});

            widgetComponent = (
                <Widget
                    key={widgetID}
                    _key={widgetID}
                    data={widget}
                    tab={this.props.tab}
                    mainTab={this.props.mainTab}
                    workspace={instance.id}
                    namespaces={this.state.namespaces}
                    isWorkspaceSaved={this.props.id != null}
                    distractFree={this.getWidgetDistractFree()}
                    hideEdit={this.props.widgetsHideEdit}
                    workspaceContextId={this.state.contextId}
                    displayMode={displayMode}
                    theme={theme}
                    widgetState={this.props.widgetState}
                    hidden={this.props.hidden}
                    globalState={this.state.globalState}
                    options={options}
                    glob={this.props.glob}
                />
            );

            return (
                <div className="layout-container">
                    <div className="inner-layout-container">
                        <LayoutContainerBlock
                            dragAllowed={displayMode === 'widgets'}
                            style={{
                                left: 0,
                                top: 0,
                                right: this.state.viewportWidth,
                                bottom: this.state.viewportHeight,
                                width: this.state.viewportWidth,
                                height: this.state.viewportHeight
                            }}
                            hidden={this.props.hidden}
                        >
                            {widgetComponent}
                        </LayoutContainerBlock>
                    </div>
                </div>
            );
        } else {
            return this.getLayout(displayMode);
        }
    };

    handleOnLayoutContainerSizeChange = (width: number, height: number) => {
        this.setState({
            viewportWidth: width,
            viewportHeight: height
        });
    };

    handleOnNavBarClick = (e) => {
        e.stopPropagation();
        e.preventDefault();
    };

    handleOnTemplateExplorerHide = () => {
        this.props.glob.AppActions.workspaceTemplatesExplorerHide();
    };

    render() {
        const { distractFree, widgetMode, glob } = this.props;
        const { instance, storeState } = this.state;
        const content: React.JSX.Element[] = [];
        const layoutType = config.LAYOUT_TYPE as WorkspaceLayoutType;
        const useTabsMode = glob.SettingsStore.useTabsMode();
        const showAppLogo = this.props.widgetState == null || this.props.widgetState.showAppLogo;
        const theme = this.getTheme();
        const pinNavigationBar = getPinNavigationBarValue(theme, glob);
        const navigationBarHeight = distractFree ? 0 : this.state.navigationBarHeight;

        let displayMode: DisplayMode;

        if (instance.showGrid || instance.displayMode == null) {
            displayMode = 'main';
        } else {
            displayMode = instance.displayMode;
        }

        let navigationBarFloatingPanel: React.JSX.Element;

        if (!distractFree) {
            const logoPosition = this.props.glob.SettingsStore.getApplicationLogoPosition();

            let logoToLeft: React.JSX.Element;
            let logoToFullLeft: React.JSX.Element;
            let logoAbove: React.JSX.Element;

            if (logoPosition === 'left') {
                logoToLeft = (
                    <ApplicationLogo
                        ref={(input) => {
                            this.refrences.leftLogo = input;
                        }}
                        position={'left'}
                        layoutType={layoutType}
                        widgetMode={widgetMode}
                        distractFree={distractFree}
                        showAppLogo={showAppLogo}
                        glob={glob}
                    />
                );
            } else if (logoPosition === 'leftFullHeight') {
                logoToFullLeft = (
                    <ApplicationLogo
                        ref={(input) => {
                            this.refrences.leftLogo = input;
                        }}
                        position={'full-left'}
                        layoutType={layoutType}
                        widgetMode={widgetMode}
                        distractFree={distractFree}
                        showAppLogo={showAppLogo}
                        glob={glob}
                    />
                );
            } else {
                logoAbove = (
                    <ApplicationLogo
                        position={'above'}
                        layoutType={layoutType}
                        widgetMode={widgetMode}
                        distractFree={distractFree}
                        showAppLogo={showAppLogo}
                        glob={glob}
                    />
                );
            }

            const navigationBar = (
                <div
                    key="navigation-bar"
                    ref={(input) => {
                        this.refrences.navigationBar = input;
                    }}
                >
                    <NavigationBar
                        id={this.props.id}
                        cid={this.props.cid}
                        tab={this.props.tab}
                        tabDisplay={this.props.tabDisplay}
                        tabs={this.props.tabs}
                        workspaceState={this.state}
                        layoutType={layoutType}
                        widgetMode={widgetMode}
                        useTabsMode={useTabsMode}
                        pinNavigationBar={pinNavigationBar}
                        hidden={this.props.hidden}
                        theme={theme}
                        glob={glob}
                        logoToLeft={logoToLeft}
                        logoToFullLeft={logoToFullLeft}
                        logoAbove={logoAbove}
                        getTopActiveButtons={() => {
                            return this.getTopActiveButtons(displayMode);
                        }}
                        getCommandMenu={() => {
                            return this.getCommandMenu(displayMode, layoutType, false, theme);
                        }}
                        onWorkspacesNavSelect={this.handleOnWorkspacesNavSelect}
                        onToggleWorkspacesNavigationBar={this.handleOnToggleWorkspacesNavigationBar}
                        onWorkspaceRemove={this.handleOnWorkspaceRemove}
                        onManualWorkspaceUpdate={this.handleManualWorkspaceUpdate}
                        onLayoutCarouselChange={this.handleOnLayoutCarouselChange}
                        onNavAndLogoChange={this.handleOnNavAndLogoChange}
                        onTogglePinNavigationBar={this.handleOnTogglePinNavigationBar}
                    />
                </div>
            );

            if (pinNavigationBar) {
                content.push(navigationBar);
            } else {
                let panelContent: React.JSX.Element;

                if (this.state.showFloatingNavigationBar) {
                    panelContent = navigationBar;
                }

                navigationBarFloatingPanel = (
                    <div
                        className="floating-navigation-bar"
                        onClick={this.handleOnNavigationBarMouseOver}
                        onMouseOver={this.handleOnNavigationBarMouseOver}
                        onMouseLeave={this.handleOnNavigationBarMouseOut}
                    >
                        {panelContent}
                    </div>
                );
            }
        }

        // on small devices -- only small button at top left corner
        if (distractFree && layoutType === 'narrow') {
            const screenWidth = $(window).width();

            content.push(
                <div
                    className="fixed-top"
                    style={{
                        left: screenWidth - 32 + 'px'
                    }}
                >
                    {this.getCommandMenu(displayMode, layoutType, true, theme, {
                        borderRadius: '32px',
                        boxShadow: '-3px 4px 15px grey',
                        fontSize: '18px'
                    })}
                </div>
            );
        }

        if (instance.showDirsTemplatesSidebar && instance.id != null && !distractFree) {
            content.push(
                <div
                    key="templates-sidebar"
                    className="templates-sidebar"
                    style={{
                        top: navigationBarHeight + 'px'
                    }}
                >
                    <DirsTemplatesFlat instanceID={'templates-sidebar'} glob={glob} />
                </div>
            );
        }

        if (!distractFree && widgetMode !== true && storeState.showSidebar && this.props.hidden !== true) {
            if (this.state.menuMode === MenuModes.sideBar) {
                content.push(
                    <div
                        key="nav-bar"
                        className="workspaces-nav-bar"
                        style={{
                            top: navigationBarHeight + 'px',
                            backgroundColor: theme['surface-bg']
                        }}
                        onClick={this.handleOnNavBarClick}
                    >
                        <WorkspacesNavigation
                            menuMode={MenuModes.sideBar}
                            id={instance.id + '-' + this.props.tab}
                            glob={glob}
                            onSelect={this.handleOnWorkspacesNavSelect}
                        />
                    </div>
                );
            }
        }

        let widgetsList: React.JSX.Element[] = [];

        if (instance.loading) {
            content.push(
                <div key="content-loading" className="content">
                    <ProgressBar />
                </div>
            );
        } else if (instance.id != null && instance.data != null) {
            // if (!useTabsMode) {
            //     const tabs = this.props.tabs;

            //     if (tabs != null && tabs.length > 0) {
            //         const firstTab = tabs[0];

            //         let tabTitle = firstTab.title;

            //         if (tabTitle == null) {
            //             const workspaceInstance = glob.WorkspaceStore.getInstanceState(instance.id);

            //             tabTitle = workspaceInstance.name;
            //         }

            //         content.push(
            //             <div className="single-tab-title" key="single-tab-title">
            //                 { tabTitle }
            //             </div>
            //         );
            //     }
            // }
            content.push(
                <LayoutContainerSize
                    key="viewport"
                    width={this.state.viewportWidth}
                    height={this.state.viewportHeight}
                    navigationBarHeight={navigationBarHeight}
                    disableSizeMixin={this.props.disableSizeMixin}
                    navigationBarlIsPinned={pinNavigationBar}
                    noTabsMode={!useTabsMode}
                    tabs={this.props.tabs}
                    workspaceName={this.state.instance.name}
                    onChange={this.handleOnLayoutContainerSizeChange}
                >
                    {this.getWidgets(displayMode)}
                </LayoutContainerSize>
            );

            if (storeState.showDirsTemplates && !distractFree) {
                content.push(
                    <DirsTemplates
                        key="select-template"
                        selectTemplateMode={true}
                        glob={glob}
                        onHide={this.handleOnTemplateExplorerHide}
                    />
                );
            }

            const freeWidgets = _.filter(instance.data.widgets, (obj, i) => {
                return instance.data.layout.pos[i] == null || instance.data.layout.size[i] == null;
            });

            widgetsList = _.map(freeWidgets, (obj) => {
                return <WidgetBrief key={obj.id || obj.cid} data={obj} glob={glob} />;
            });

            content.push(
                <div key="widgets-list" className="widgets-list">
                    <div className="title" key="detached-widgets">
                        {'Detached widgets'}
                    </div>

                    {widgetsList}
                </div>
            );
        }

        if (
            this.props.id == null &&
            !(
                instance.data == null ||
                instance.data.widgets.length > 0 ||
                instance.data.layout.rows.length > 1 ||
                instance.data.layout.columns.length > 1
            ) &&
            displayMode === 'main'
        ) {
            content.push(
                <IntroView key="intro-view" navigationBarHeight={navigationBarHeight} theme={theme} glob={glob} />
            );
        }

        let renderedTheme: React.JSX.Element;

        const containerElementId = 'workspace-' + instance.id + '-' + this.props.tab;

        if (widgetMode) {
            renderedTheme = (
                <ThemeRenderer theme={this.props.theme} levels={['workspace']} context={'#' + containerElementId} />
            );
        }

        return (
            <ErrorBoundary>
                <div
                    style={{
                        position: 'absolute',
                        top: '0',
                        bottom: '0',
                        left: '0',
                        right: '0',
                        display: this.props.hidden ? 'none' : undefined
                    }}
                >
                    <div
                        id={containerElementId}
                        className={
                            'workspace-view-container' +
                            (widgetsList.length > 0 ? ' widgets-list-visible' : '') +
                            (instance.showDirsTemplatesSidebar && !instance.showGrid
                                ? ' templates-sidebar-visible'
                                : '') +
                            (storeState.showSidebar ? ' workspaces-bar-visible' : '') +
                            (!distractFree ? ' show-actions' : '') +
                            ' mode-' +
                            displayMode +
                            (instance.showGrid ? ' mode-grid' : '') +
                            (this.props.hidden ? ' hidden' : '') +
                            ' layout-' +
                            layoutType
                        }
                    >
                        {renderedTheme}
                        <Dialogs glob={this.props.glob} tabID={this.props.tab} pinNavigationBar={pinNavigationBar} />
                        {navigationBarFloatingPanel}
                        {content}
                    </div>
                </div>
            </ErrorBoundary>
        );
    }
}
